import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UIState } from '../../types/store';

const initialState: UIState = {
  sidebarOpen: true,
  darkMode: false,
  fontSize: 'medium',
  language: 'ko',
  notifications: [],
  modal: null
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setDarkMode: (state, action: PayloadAction<boolean>) => {
      state.darkMode = action.payload;
    },
    setFontSize: (state, action: PayloadAction<'small' | 'medium' | 'large'>) => {
      state.fontSize = action.payload;
    },
    setLanguage: (state, action: PayloadAction<'ko' | 'en'>) => {
      state.language = action.payload;
    },
    setModal: (state, action: PayloadAction<UIState['modal']>) => {
      state.modal = action.payload;
    }
  }
});

export const { 
  toggleSidebar, 
  setDarkMode, 
  setFontSize, 
  setLanguage, 
  setModal 
} = uiSlice.actions;

export default uiSlice.reducer; 